<template>
  <nav class="fixed top-0 left-0 w-full z-50 bg-gradient-to-r from-blue-600 to-purple-600 shadow-xl rounded-b-2xl">

    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16">
        <!-- Logo/Brand -->
        <div class="flex-shrink-0 flex items-center">
          <svg class="h-8 w-8 text-white" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 7v10l10 5 10-5V7L12 2zm0 2.8L20 9v6l-8 4-8-4V9l8-4.2z"/>
            <path d="M12 16l-4-2v-4l4 2 4-2v4l-4 2z"/>
          </svg>
          <span class="ml-2 text-white text-xl font-bold bg-clip-text">Sunrack RCC Kit</span>
        </div>

        <!-- Desktop Navigation -->
        <div class="hidden md:block">
          <div class="ml-10 flex items-center space-x-4">
            <!-- Home -->
            <router-link
                to="/home"
                class="group relative px-3 py-2 text-sm font-medium rounded-md transition-all duration-300"
                active-class="text-blue-200"
            >
              <span class="text-white group-hover:text-blue-200">Home</span>
              <span
                  class="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-300 transition-all duration-300 group-hover:w-full"></span>
            </router-link>

            <!-- Create Enquiry -->
            <router-link
                to="/createenquiry"
                class="group relative px-3 py-2 text-sm font-medium rounded-md transition-all duration-300"
                active-class="text-blue-200"
            >
              <span class="text-white group-hover:text-blue-200">Create Sales Order</span>
              <span
                  class="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-300 transition-all duration-300 group-hover:w-full"></span>
            </router-link>

            <!-- Confirmed Orders -->
            <router-link
                to="/confirmedorders"
                class="group relative px-3 py-2 text-sm font-medium rounded-md transition-all duration-300"
                active-class="text-blue-200"
            >
              <span class="text-white group-hover:text-blue-200">Orders Tracker</span>
              <span
                  class="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-300 transition-all duration-300 group-hover:w-full"></span>
            </router-link>

            <router-link
                to="/WarrantyGenerator"
                class="group relative px-3 py-2 text-sm font-medium rounded-md transition-all duration-300"
                active-class="text-blue-200"
            >
              <span class="text-white group-hover:text-blue-200">Warranty Generator
              </span>
              <span
                  class="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-300 transition-all duration-300 group-hover:w-full"></span>
            </router-link>

            <!-- Logout -->
            <a
                href="#"
                @click.prevent="Logout"
                class="group relative px-3 py-2 text-sm font-medium rounded-md transition-all duration-300"
            >
              <span class="text-white group-hover:text-blue-200">Logout</span>
              <span
                  class="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-300 transition-all duration-300 group-hover:w-full"
              ></span>
            </a>

          </div>
        </div>

        <!-- Mobile menu button -->
        <div class="md:hidden flex items-center">
          <button
              @click="isOpen = !isOpen"
              type="button"
              class="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-blue-200 hover:bg-blue-700 focus:outline-none transition duration-150 ease-in-out"
              aria-expanded="false"
          >
            <span class="sr-only">Open main menu</span>
            <svg
                class="h-6 w-6"
                :class="{'hidden': isOpen, 'block': !isOpen}"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
            </svg>
            <svg
                class="h-6 w-6"
                :class="{'hidden': !isOpen, 'block': isOpen}"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile Navigation -->
    <div class="md:hidden" :class="{'hidden': !isOpen, 'block': isOpen}">
      <div class="px-2 pt-2 pb-3 space-y-1">
        <router-link
            to="/home"
            class="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-blue-700 transition duration-150 ease-in-out"
            @click="isOpen = false"
            active-class="bg-blue-700"
        >
          Home
        </router-link>
        <router-link
            to="/createenquiry"
            class="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-blue-700 transition duration-150 ease-in-out"
            @click="isOpen = false"
            active-class="bg-blue-700"
        >
          Create Enquiry
        </router-link>
        <router-link
            to="/confirmedorders"
            class="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-blue-700 transition duration-150 ease-in-out"
            @click="isOpen = false"
            active-class="bg-blue-700"
        >
          Confirmed Orders
        </router-link>
        <router-link
            to="/"
            class="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-blue-700 transition duration-150 ease-in-out"
            @click="isOpen = false"
            active-class="bg-blue-700"
        >
          Logout
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>

export default {
  name: 'NabigationBar',
  data() {
    return {
      isOpen: false
    }
  },
  watch: {
    $route() {
      // Close mobile menu when route changes
      this.isOpen = false
    }
  },
  methods: {
    Logout() {
      localStorage.clear();
      this.$router.push('/')
      /* login details are stored in our localStorage so for logout we just clear the
      localStorage and redirect the user to login page so user will be log out */
    }
  },
}
</script>

<style scoped>

</style>